import { FC } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { useDataRoom, useDeleteDataRoom } from '../../../../hooks/space/index';
import { DataRoomModalType } from '../../enums/data-room-modal-type.enum';
import { DataRoomModalStore } from '../../store/data-room-modal.store';
import { ConfirmDeleteModal } from './confirm-delete-modal';

export const DeleteDataRoomModal: FC = () => {
  const isOpen = DataRoomModalStore(({ isOpen }) => isOpen);
  const type = DataRoomModalStore(({ type }) => type);
  const dataRoomId = DataRoomModalStore(({ metadata }) => metadata?.spaceId);
  const handleDismiss = DataRoomModalStore(({ handleDismiss }) => handleDismiss);

  const { dataRoom } = useDataRoom(dataRoomId);
  const { deleteDataRoom, isPending } = useDeleteDataRoom();

  if (type !== DataRoomModalType.DELETE_DATA_ROOM || !dataRoomId) {
    return null;
  }

  const confirm = () => {
    if (isPending) return;

    deleteDataRoom({ id: dataRoomId }, { onSuccess: () => handleDismiss() });
  };

  return (
    <ConfirmDeleteModal
      body={
        <AppFormattedMessage
          id="DELETE_DATA_ROOM_CONFIRMATION"
          values={{ name: dataRoom?.name ?? '' }}
        />
      }
      isOpen={isOpen}
      isPending={isPending}
      onCancel={handleDismiss}
      onConfirm={confirm}
      title={<AppFormattedMessage id="DELETE_DATA_ROOM_TITLE" />}
    />
  );
};
